import classNames from 'classnames'
import { ISkeletonProps } from '.'

const SkeletonRectangular = ({ w, h, className }: ISkeletonProps) => {
  return (
    <div
      style={{
        width: w,
        height: h,
      }}
      className={classNames('animate-pulse rounded-md bg-gray-100', className)}
    ></div>
  )
}

export default SkeletonRectangular
